import React from 'react'

// Un drapeau par langue (le choix se fait sur le drapeau, jamais sur le nom de la langue)
const FLAGS = {
	fr: { flag: '🇫🇷', name: 'Français' },
	en: { flag: '🇬🇧', name: 'English' },
	de: { flag: '🇩🇪', name: 'Deutsch' },
	nl: { flag: '🇳🇱', name: 'Nederlands' },
	it: { flag: '🇮🇹', name: 'Italiano' },
	es: { flag: '🇪🇸', name: 'Español' },
	pt: { flag: '🇵🇹', name: 'Português' }
}

// Drapeaux côte à côte, de gauche à droite : un clic sur un drapeau change la langue immédiatement
export default function LangFlagPicker({ langs, current, onChange })
{
	const available = langs.filter(lang => FLAGS[lang])
	if (available.length < 2)
		return null
	const active = FLAGS[current] ? current : available[0]
	return (
		<div role="group" aria-label="Langue" className="flex items-center gap-1">
			{available.map(lang => (
				<button
					key={lang}
					type="button"
					aria-label={FLAGS[lang].name}
					aria-pressed={lang === active}
					onClick={() => onChange(lang)}
					className={'rounded-full px-1.5 py-1 text-2xl leading-none focus:outline-none transition ' + (lang === active ? 'bg-gray-100 ring-2 ring-gray-300' : 'opacity-60')}
				>
					<span aria-hidden="true">{FLAGS[lang].flag}</span>
				</button>
			))}
		</div>
	)
}
